import React from "react";
import PageTitle from "../PageTitle";
import { doRequest } from "../../helper";
import $ from "jquery";
import { NavLink } from "react-router-dom";
import LazyLoad from "react-lazyload";
import axios from "axios";
export default class Rb2020 extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      items: [],
      response: null,
      postCount: 0,
      status: "Active",
      // lastEvaluatedKey: "",
      loadMoreDisplay: false,
    };
    this.update = this.update.bind(this);
    this.getPosts = this.getPosts.bind(this);
    this.batchUpdate = this.batchUpdate.bind(this);
    this.selectToggle = this.selectToggle.bind(this);
  }
  componentDidMount() {
    var status = this.props.match.params.status;
    if (!status) {
      status = "enabled";
    }

    this.getPosts(status);
  }
  componentWillReceiveProps(nextProps) {
    var status = nextProps.match.params.status;
    if (!status) {
      status = "enabled";
    }
    this.setState({ lastEvaluatedKey: "" }, () => {
      this.getPosts(status);
    });
    // this.getPosts(status);
  }
  getPosts(status, loadmore) {
    $("#loader").css({ display: "block" });
    var ref = this;
    if (!loadmore) {
      ref.setState({ items: [] });
    }

    var request = doRequest(
      "cms-operations2",
      {
        action: "list-posts",
        module: "harghartiranga",
        model: "post",
        lastEvaluatedKey: ref.state.lastEvaluatedKey,
        data: {
          direction: "desc",
          status: status,
          limit: 100,
        },
      },
      true
    );
    request.addEventListener("load", function () {
      var response = this.responseText;
      try {
        response = JSON.parse(response);
        if (response._resultflag && response._resultflag == 1) {
          console.log(ref.state.items);
          console.log(response.Count);
          let loadMoreItems = loadmore
            ? [...ref.state.items, ...response.items]
            : response.items;
          console.log(loadMoreItems);
          if (response.items.length > 99) {
            ref.setState({
              loadMoreDisplay: true,
            });
          } else {
            ref.setState({
              loadMoreDisplay: false,
            });
          }
          ref.setState(
            {
              response: response,
              items: loadMoreItems,
              lastEvaluatedKey: response.lastEvaluatedKey,
              postCount: response.countdata.Count,
              status: status,
            },
            () => {
              $("#loader").css({ display: "none" });
            }
          );
        }
      } catch (ex) {}
    });
  }
  batchUpdate(status) {
    var ids = [];
    var createds = [];
    $(".multi_select:checked").each(function () {
      ids.push($(this).attr("data-id"));
      createds.push($(this).attr("data-created"));
    });
    var id = ids.join(",");
    var created = createds.join(",");

    if (id == "") {
      alert("No post selected");
    } else {
      this.update(id, created);
    }
  }
  update = async (id, created) => {
    $("#loader").css({ display: "block" });
    var data = JSON.stringify({
      action: "update-mygov",
      data: {
        id: id,
        mygov: "0",
        created: created,
      },
    });
    let req = await axios({
      method: "POST",
      headers: { "Content-Type": "application/json" },
      url: "https://campaign-api.narendramodi.in/har_ghar_tiranga",
      data: data,
    });
    console.log("okokoko", req.data);
    try {
      $("#loader").css({ display: "none" });
      if (req.data && req.data._resultflag == "1") {
        var ids = req.data.id;
        $("#post_" + ids).hide();
      }
    } catch (ex) {}
  };
  loadMoreData = () => {
    let ep = null;
    var status = this.props.match.params.status;
    this.getPosts(status, "loadmore");
  };
  selectToggle() {
    if ($(".allChecked").length > 0) {
      $(".multi_select").prop("checked", false);
      $(".multi_select").removeClass("allChecked");
    } else {
      $(".multi_select").prop("checked", true);
      $(".multi_select").addClass("allChecked");
    }
  }

  render() {
    var bread = "HarGharTiranga / Moderation (Active Posts)";
    var pagelink = "/harghartiranga/moderation";
    if (this.props.match.params.status == "disabled") {
      bread = "HarGharTiranga/ Moderation (Disabled Posts)";
      pagelink += "/disabled";
    } else {
      pagelink += "/enabled";
    }
    var items = this.state.items;
    var links = [
      {
        link: "/harghartiranga/moderation/disabled",
        name: "View Disabled Posts",
      },
      {
        link: "/harghartiranga/moderation/enabled",
        name: "View Active Posts",
      },
    ];
    var pagination = [];
    if (this.state.response && countdata) {
      var countdata = this.state.response.countdata;
      var pages = Math.ceil(countdata.Count / this.state.limit);

      for (var i = 1; i <= pages; i++) {
        pagination.push(
          <span key={i}>
            <NavLink to={pagelink + "/" + i} className="btn btn-primary btn-xs">
              {i}
            </NavLink>
            &nbsp;
          </span>
        );
      }
    }

    return (
      <div>
        <PageTitle
          title="#HarGharTiranga"
          bread={bread}
          links={links}
          Count={this.state.postCount}
          counttype={
            this.state.status == "enabled"
              ? "Active "
              : this.state.status == "disabled"
              ? "Inactive "
              : ""
          }
        />
        <div className="wrapper wrapper-content">
          {/* <div className="media-body ">
            <span style={{ position: "relative", top: "5px" }}>
              &nbsp; Page : {pagination}
              &nbsp;&nbsp;
            </span>
          </div> */}
          <br />
          <div className="row">
            <div className="col-lg-12">
              <div className="kamal_list">
                <p
                  id="nodatafound"
                  style={{
                    display: "none",
                    textAlign: "center",
                    position: "relative",
                    left: "50%",
                    transform: "translateX(-50%)",
                  }}
                >
                  No Data Found
                </p>
                {Array.isArray(items) &&
                  items.map((value, index) => {
                    return (
                      <div class="file-box" key={index} id={"post_" + value.id}>
                        <div class="file">
                          <a href="javascript:void(0);">
                            <span class="corner"></span>
                            <LazyLoad>
                              <div class="image" style={{ height: "auto" }}>
                                <img
                                  alt="image"
                                  class="img-responsive"
                                  src={value.post_url}
                                />
                                <div className="image_caption">
                                  <a
                                    href="javascript:void(0);"
                                    className="btn btn-warning btn-circle"
                                    onClick={() => {
                                      this.update(value.id, value.created);
                                    }}
                                    type="button"
                                  >
                                    <i className="fa fa-times"></i>
                                  </a>
                                </div>
                              </div>
                            </LazyLoad>
                            <div class="file-name">
                              {value.post_type ? value.post_type : ""}
                              <br />
                              <small>
                                Added: {value.created ? value.created : ""}
                              </small>
                            </div>
                          </a>
                        </div>
                      </div>
                    );
                  })}
              </div>
            </div>
            {this.state.loadMoreDisplay && (
              <button
                style={{
                  position: "relative",
                  left: "50%",
                  transform: "translateX(-50%)",
                  padding: "10px 18px",
                }}
                type="button"
                onClick={this.loadMoreData}
              >
                Load More
              </button>
            )}
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/Components/HarGharTiranga/Moderation.jsx